export const LEGAL_VERSIONS = {

  terms: "2026.1",

  privacy: "2026.1",

  conduct: "2026.1",

  subscriptions: "2026.1",

  manifesto: "1.0",

} as const;